import { AccountTreeOutlined } from '@material-ui/icons'
import { useDialogManager } from 'features/DialogManager/DialogManager'
import { BomItemMenuItem } from './BomItemMenuItem'

export const AssemblySimplificationMenuItem = ({
  bomItemId,
  onClose,
}: {
  bomItemId: string
  onClose: () => void
}) => {
  const { openDialog } = useDialogManager()

  const handleOpen = () => {
    openDialog('AssemblySimplification', {
      assemblyId: bomItemId,
      open: true,
    })
  }

  return (
    <BomItemMenuItem
      onClick={handleOpen}
      closeOnClick
      onClose={onClose}
      primaryTextTranslationKey="project:vertical-menu-assembly-simplification"
      secondaryTextTranslationKey="project:vertical-menu-assembly-simplification-subtitle"
      icon={<AccountTreeOutlined style={{ transform: 'scale(-1, 1)' }} />}
      hiddenForBuyers
      disableIfNotEditable
    />
  )
}
